<router-outlet></router-outlet>
<style [attr.nonce]="9+EESzFcGU2jLYNVO/U4+DGT8xNk4iKbkeEC1i1XulI=">
</style>